export default {
    ADMIN: 'Admin',
    BACKOFFICE: 'Backoffice',
    CLIENT: 'Client',
    GENERATOR: 'Generator',
    CLIENTGENERATOR: 'ClientGenerator'
};


